<template>
  <div>
         <el-row :gutter="3">
           <el-col :span="9">
              <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="6">
                  <el-input
                    clearable
                    v-model="priceRuleItemObject.priceStart"
                    placeholder="请输入正整数"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  ></el-input
                ></el-col>
                <el-col :span="2">元 ~ </el-col>
                <el-col :span="6">
                  <el-input
                    clearable
                    v-model="priceRuleItemObject.priceEnd"
                    placeholder="请输入正整数"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  ></el-input>
                </el-col>
                <el-col :span="4">元(含)</el-col>
              </el-row>
           </el-col>
           <el-col :span="3">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                   <el-input clearable v-model="priceRuleItemObject.timeLimit"></el-input>
                 </el-col>
              </el-row>
           </el-col>
           <el-col :span="2">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                  <el-select
                    style="width:100%"
                    v-model="priceRuleItemObject.gradeId"
                    filterable
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in gradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                 </el-col>
              </el-row>
           </el-col>
           <el-col :span="3">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                   <el-input clearable v-model="priceRuleItemObject.limitPrice"></el-input>
                 </el-col>
              </el-row>
           </el-col>
           <el-col :span="3">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                  <el-select
                    style="width:100%"
                    v-model="priceRuleItemObject.dispatchOrderRoleType"
                    filterable
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in dispatchOrderRoleTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                 </el-col>
              </el-row>
           </el-col>
              <el-col :span="2">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                  <el-select
                    style="width:100%"
                    v-model="priceRuleItemObject.accessDeductionOptionFlag"
                    filterable
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in accessDeductionOptionList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                 </el-col>
              </el-row>
           </el-col>
           <el-col :span="1">
            <el-button
                  style="margin-left:5px"
                  icon="el-icon-delete"
                  @click="deletePriceRuleItem()"
                ></el-button>
           </el-col>
         </el-row>
  </div>
</template>

<script>
export default {
  name: "PriceRuleItem",
  components: {},
  props: [
    "priceRuleItemObject",
    "gradeList",
    "dispatchOrderRoleTypeList",
    "accessDeductionOptionList",
    "itemIndex",
  ],
  data() {
    return {
    };
  },
  watch: {
  },
  computed: {},
  methods: {
    deletePriceRuleItem(){
       this.$emit(
        "deletePriceRuleItem",
        this.$props.itemIndex
      );
    },
  },
  created() {},
  mounted() {
  },
};
</script>
<style lang="less" scoped></style>
